import api from './baseAPIService';

export const initiatePayPalCheckout = async () => {
  try {
    const response = await api.post('/payments/paypal/create');
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to initiate PayPal checkout' };
  }
};

export const initiateStripeCheckout = async () => {
  try {
    const response = await api.post('/payments/stripe/create');
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to initiate Stripe checkout' };
  }
};

export const verifyPayment = async (paymentId, provider) => {
  try {
    const response = await api.post('/payments/verify', {
      payment_id: paymentId,
      provider: provider
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to verify payment' };
  }
};

export const getSubscriptionStatus = async () => {
  try {
    const response = await api.get('/payments/subscription/status');
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to get subscription status' };
  }
};

export const requestRefund = async () => {
  try {
    const response = await api.post('/payments/refund');
    return response.data;
  } catch (error) {
    throw error.response?.data || { detail: 'Failed to process refund request' };
  }
}; 